import { render } from "./SDSTableUnauth.vue?vue&type=template&id=ba24308a"
import script from "./SDSTableUnauth.vue?vue&type=script&lang=js"
export * from "./SDSTableUnauth.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__